module.exports = __webpack_public_path__ + "img/CZ47116129.664544a6.png";